module.exports = __webpack_public_path__ + "img/Crownhill_Finished_hover.168cf54d.jpg";